import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CYCLE_STATUS_LEGEND, CycleStatusKey } from '../cycle-status.util';

@Component({
  selector: 'app-alert-status-legend-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h1 mat-dialog-title>Alert Status Legend</h1>
    <div mat-dialog-content>
      <ul class="legend">
        @for (item of legend; track item.key) {
          <li>
            <span [class]="badgeClass(item.key)">{{ item.label }}</span>
            <p>{{ item.description }}</p>
          </li>
        }
      </ul>
    </div>
    <div mat-dialog-actions>
      <button mat-button type="button" (click)="dialogRef.close()">Close</button>
    </div>
  `,
  styleUrl: './alert-status-legend-dialog.component.scss',
})
export class AlertStatusLegendDialogComponent {
  readonly legend = CYCLE_STATUS_LEGEND;

  constructor(public dialogRef: MatDialogRef<AlertStatusLegendDialogComponent>) {}

  badgeClass(key: CycleStatusKey): string {
    return `cycle-status-badge cycle-status-badge--${key}`;
  }
}
